import { Injectable } from '@angular/core';
import { TranslationValues } from '../translate.service';
import { Compiler } from './compiler';
import { Locale } from '../../../enums/locale.enum';

@Injectable({
  providedIn: 'root',
})
export class CompilerService implements Compiler {
  public exec(
    locale: Locale,
    message: string,
    values?: TranslationValues
  ): string {
    if (!values) {
      return message;
    }

    return message.replaceAll(/{([^}]+)}/g, (match: string, key: string) => {
      return values[key]?.toString() ?? match;
    });
  }
}
